import autoTable from "jspdf-autotable";

import { format } from "crypto-js";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

    function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}



  const columnStyles = {
    0: { cellWidth: 40, halign: "right" },
    1: { cellWidth: 50, halign: "right" },
    2: { cellWidth: 50, halign: "right" },
    3: { cellWidth: 50, halign: "right" },
    
      
  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  // doc.setFillColor(52, 100, 160);
  // doc.rect(14, startY - 10, 190, 8, "F");

  // doc.setTextColor(255);
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(10);
  //doc.text(` ${shop} Railway`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[
      
      "Allocation",
      "Data From Demand 6",
      "Data From Other Railway (C/1)",
      "Total",
      
    ]],

    body: rows.map((r) => [
      (r.workorder),
      format(r.DrAmount),
      format(r.CrAmount),
      format(r.DrAmount - r.CrAmount),
     
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 190, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`TOTAL`, 40, y + 5);

  // Debit Total
  doc.text(format(total.DrAmount),102, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.CrAmount) , 152, y + 5, {
    align: "right",
  });

  // Labour Cost Total
  doc.text(format(total.total), 202, y + 5, {
    align: "right",
  });

  
  // Reset text color
  doc.setTextColor(0);

// Reserve space after Depot Total
doc.lastAutoTable.finalY = y +  5;
//                 rectangle height ^   ^ extra space
}



